/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';

import config from 'app-config';
import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import '@xengage/gw-platform-translations';
import { MLPAVehicleGarageLocationComponent } from 'ml-components-common-react';
import { MLPublicContactsService } from 'gw-capability-quoteandbind';
import metadata from './MLPAEditVehicleComponent.metadata.json5';
import styles from './MLPAEditVehicleComponent.module.scss';
import messages from './MLPAEditVehicleComponent.messages';
import {platformMessages} from "ml-components-platform-react";
import {MLVehicleInfoLookupService} from "ml-services-common-react";
import {MLDriverVehicleUtil, MLNotificationBlockUtil} from "ml-portals-util-react";
import {MLModalService} from "ml-portals-services-react";
import { MLProductCodeUtil } from 'ml-portals-util-js';
import { DateInput } from '@jutro/components/new';
import moment from 'moment';
import MLPARegisteredOwnersComponent from '../MLPARegisteredOwnersComponent/MLPARegisteredOwnersComponent'

function MLPAEditVehicleComponent(props) {
    const {
        vehicleVM,
        submissionVM,
        showValidtionErrors,
        handleVehicleModelChange,
        onValidate,
        vehicleHeaderMessage,
        bodyTypename,
        showTrim,
        showCylinders,
        policyAddress,
        effectiveDate,
        updateViewModel,
        isFieldDefaultedByHvq,
        isCompRaterDefaultsPage,
        showVehicleHeader,
        isAddOrReplace,
        isEndorsement,
        authHeader,
        updateWizardData,
        onRegisteredOwnerChange,
        showAltAddressStateError,
        purchaseDateInputError,
        resetGarageValidation,
        showGarageAddressError
    } = props;

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const { refreshData } = useDataRefresh();
    const [showOwnedLessthanSixmonths, setshowOwnedLessthanSixmonths] = useState(false);
    const [potentialContacts, updatePotentialContacts] = useState([]);
    const [potentialContactsLoading, updatePotentialContactsLoading] = useState(true);
    const translator = useTranslator();

    const isAMP = config.portalCode === 'AMP';
    const isQnb = config.portalCode === 'QB';
    const [availableLocations, updateAvailableLocations] = useState([]);
    const [currentVehicleIndex, setCurrentVehicleIndex] = useState();
    const vehiclesVMPath = 'lobData.personalAuto.coverables.vehicles';
    const vehicleListValue = _.get(submissionVM, `${vehiclesVMPath}.value`, [])
	      //new product
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const isModernProductPersonalAuto = isModernProduct && MLProductCodeUtil.isPersonalAuto(_.get(submissionVM, 'baseData.productCode.value'));

    const currentYear = new Date().getFullYear();
    const hasYear = () => !!vehicleVM.value.year;
    const isVehicleYearPre1981 = () => hasYear() && vehicleVM.value.year < 1981 && vehicleVM.value.year > 1969;

    const isVehicleOfCategory = (category) => {
        return category === _.get(vehicleVM, 'category_ML.value.code', '');
    };

    const isPrivatePassenger = () => isVehicleOfCategory('private_passenger_light_truck');
    // const isOtherPersonallyRegistered = () => isVehicleOfCategory('Other_Personally_Registered');
    const isCollectible = () => isVehicleOfCategory('collectible');
    const isTrailer = () => isVehicleOfCategory('trailer') || isVehicleOfCategory('trailer_np');
    const isTrailerNP = () => isVehicleOfCategory('trailer_np');
    const isCamper = () => isVehicleOfCategory('camper_np')
    const policyAddressNP = _.get(submissionVM, 'baseData.policyAddress.value', {});
    const isPrivatePassengerNP = () => isVehicleOfCategory('private_passenger_np');
    const isWhereParkedRequired = () => isPrivatePassenger() || isCollectible() || isPrivatePassengerNP() || isTrailerNP() || isCamper();
    const isAnnualMileageRecentOrModeled = () => vehicleVM.value.isAnnualMileageRecentOrAutoCheck;
    const {
        createLookupCompCollRequest
    } = MLDriverVehicleUtil();

        const {
            addWarningAlert,
            clearBlockAlerts,
    } = MLNotificationBlockUtil();
    
    const isIncompleteGarageAddress = () => {
      const address = _.get(vehicleVM, "garagingLocation_ML.value", {});

      return (
        _.get(vehicleVM, "parkedAtPrimary_ML.value") === false &&
        !!address?.country &&
        !address?.addressLine1
      );
    };

    const [selectedGarageAddress, setSelectedGarageAddress] = useState(() =>
      isIncompleteGarageAddress() ? "Add New Address" : undefined,
    );

    const [showAddNewAddressSection, setShowAddNewAddressSection] = useState(
      () => isIncompleteGarageAddress(),
    );


    const handleValueChange = (value, path) => {
        _.set(vehicleVM, path, value);
        refreshData();
        updateWizardData(submissionVM);
    };

    const getQuoteID = () => {
        return isAMP ? submissionVM.jobID.value : submissionVM.quoteID.value;
    };

    const isVinValid = () => {
        const vinIntegrationInvalidCodes = ['5', '4', 'N', '6', 'S', 'L', 'X'];
        const vinIntegrationValid = !vehicleVM.vinIntegrationErrorCode_ML
            || (vehicleVM.vinIntegrationErrorCode_ML.value && vinIntegrationInvalidCodes.indexOf(vehicleVM.vinIntegrationErrorCode_ML.value) === -1);

        return vehicleVM.vin.aspects.valid && vinIntegrationValid;
    };

    const setCostNewRequired = () => { vehicleVM.isCostNewRequired_ML = vehicleVM.vin?.value?.length === 17 ? !isVinValid() : true; };

    const lookupCollision = async (focusTarget) => {
        const vehicleYear = vehicleVM.year.value ? vehicleVM.year.value.toString() : null;
        const req = createLookupCompCollRequest(
            vehicleYear,
            _.get(vehicleVM, "makeCode_ML.value"),
            _.get(vehicleVM, "modelCode_ML.value"),
            getQuoteID(),
            _.get(vehicleVM, "type_ML.value.code"),
            _.get(vehicleVM, "category_ML.value.code"),
            _.get(vehicleVM, "comprehensiveSymbol_ML.value"),
            _.get(vehicleVM, "collisionSymbol_ML.value"),
            _.get(vehicleVM, "costNew.value"),
            _.get(vehicleVM, "trim_ML.value")
        );

        showProgressDialog(platformMessages.loading);

        try {
            const vehicleInfo = await MLVehicleInfoLookupService.lookUpCollisionCompSymbol(req, authHeader);

            if (vehicleInfo.comprehensiveSymbol_ML && vehicleInfo.collisionSymbol_ML) {
                _.set(vehicleVM, "comprehensiveSymbol_ML.value", vehicleInfo.comprehensiveSymbol_ML);
                _.set(vehicleVM, "collisionSymbol_ML.value", vehicleInfo.collisionSymbol_ML);
                _.set(vehicleVM, "hasSymbolsFilledByCostNew_Ext.value", true);
            }
        } finally {
            hideProgressDialog();

            if (focusTarget) {
                setTimeout(()=> { focusTarget.focus()}, 0)
            }
        }
    };

    const onBlurCostNew = (evt) => {
        const target = evt.relatedTarget;
        const value = _.get(vehicleVM, "costNew.amount.value");
        
        if (_.isUndefined(value) || _.isNull(value)) {
            vehicleVM.costNew.amount = undefined;
        } else if (!vehicleVM.value.compCollFilledByVinML && value !== 0) {
            lookupCollision(target);
        }
    }

    const isFinancedOrLeased = () => {
        return vehicleVM.value.financeCategory_ML === 'financed' || vehicleVM.value.financeCategory_ML === 'leased';
    };


    const getCarPurchaseAvailableYears = () => {
        const currentYear = new Date().getUTCFullYear();
        const { oldestCarYear } = config.personalAutoConfig;
        // _.range is not inclusive. Need to add -1 to get correct years
        const yearRange = _.range(currentYear, oldestCarYear - 1);
        const years = yearRange.map(_.toString).map((year) => ({
            code: year,
            name: year
        }));
        return years;
    };

    const syncAddresses = () => {
        if (_.isUndefined(vehicleVM.parkedAtPrimary_ML.value)) {
            vehicleVM.garagingLocation_ML = policyAddress;
            vehicleVM.parkedAtPrimary_ML.value = true;
        }

        if (!vehicleVM.garagingLocation_ML.value && vehicleVM.parkedAtPrimary_ML.value) {
            vehicleVM.garagingLocation_ML = policyAddress;
        }
    };

    const checkOwnedLessThanSixMonths = useCallback(async (value, path) => {
        // reassign value var to proper shape if only year is provided by dropdown
        if (path === "purchaseDate_ML" && value !== undefined && typeof value === "string") {
            value = {
                year: parseInt(value),
                day: 1
            }
        }
        _.set(vehicleVM, path, value);
        if (!vehicleVM.purchaseDate_ML.value) {
            setshowOwnedLessthanSixmonths(false);
            vehicleVM.ownedLessThan6Months_Ext.value = false;
        } else {
            const effectiveMonth = effectiveDate.month + 1;
            const currentYear = new Date().getFullYear();

            if (vehicleVM.purchaseDate_ML.value.year === currentYear - 1) {
                if (effectiveMonth < 6) {
                    setshowOwnedLessthanSixmonths(true);
                } else {
                    setshowOwnedLessthanSixmonths(false);
                    vehicleVM.ownedLessThan6Months_Ext.value = false;
                }
            } else if (vehicleVM.purchaseDate_ML.value.year === currentYear) {
                if (effectiveMonth > 6) {
                    setshowOwnedLessthanSixmonths(true);
                } else {
                    setshowOwnedLessthanSixmonths(false);
                    vehicleVM.ownedLessThan6Months_Ext.value = true;
                }
            } else {
                setshowOwnedLessthanSixmonths(false);
                vehicleVM.ownedLessThan6Months_Ext.value = false;
            }
        }
        updateViewModel();
    }, [effectiveDate, updateViewModel, vehicleVM]);

    const showPurchaseDateMonths = () => {
        const state = policyAddress.state.value?.code;
        return state === 'NY' || state === 'NJ';
    };
    
    const checkMatureDriverDiscount = () => {
        for (const driver of drivers ?? []) {
            const modifiers = _.get(driver, "driverModifiers_ML.modifiers");
            const isMatureDriverDiscountApplied = modifiers?.find(modifier => modifier?.codeIdentifier_ML === "PAMatureDriver_Ext")?.chosenTermValue === "true";
            if (isMatureDriverDiscountApplied) {
                clearBlockAlerts('matureDriverWarningMsgAlert');
                const primaryVehicleFixedId = _.get(driver, "driverModifiers_ML.primaryVehicleFixedId");
                const primaryVehicleUse = vehicleListValue?.find(vehicle => vehicle?.fixedId === primaryVehicleFixedId)?.primaryUse;
                if (primaryVehicleUse !== "pleasure") {
                    const matureDriverWarningMsg = messages.matureDriverDiscountWarning;
                    addWarningAlert(matureDriverWarningMsg, 'matureDriverWarningMsgAlert');
                    window.scrollTo(0, 0);
                    return;
                }
            }
        }
    };

     const removeDuplicates = (arr) => {
            const uniqueSet = new Set();

            return arr.filter((obj) => {
              if (!obj || typeof obj.name !== "string") {
                console.warn("Invalid location:", obj);

                return false;
              }

              if (uniqueSet.has(obj.name)) {
                return false;
              }

              uniqueSet.add(obj.name);

              return true;
            });
          };

     const setDefaultAmounts = useCallback(() => {
            const valueMlAmount = _.get(vehicleVM, 'value_ML.amount.value', undefined);
            if (_.isUndefined(valueMlAmount)) {
                _.set(vehicleVM, 'value_ML.value', { amount: undefined });
            }
    
            const costNewAmount = _.get(vehicleVM, 'costNew.amount.value', undefined);
            if (_.isUndefined(costNewAmount)) {
                _.set(vehicleVM, 'costNew.value', { amount: 0 });
            }
        }, [vehicleVM]);

    useEffect(() => {
        if (authHeader) {
            MLPublicContactsService.getMortgageeContacts(authHeader).then((data) => {
                updatePotentialContacts(data);
            }).finally(() => updatePotentialContactsLoading(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        checkMatureDriverDiscount();
    }, [vehicleVM.value.primaryUse]);

    useEffect(() => {
        const initVehicleValue = () => {
            setCostNewRequired();

            if (_.isEmpty(vehicleVM.costNew.value)) {
                vehicleVM.costNew.value = {
                    amount: undefined,
                    currency: 'usd'
                };
            }

            if (_.isEmpty(vehicleVM.value_ML.value)) {
                vehicleVM.value_ML.value = {
                    amount: undefined,
                    currency: 'usd'
                };
            }

            vehicleVM.salvagedTitle_ML.value = vehicleVM.salvagedTitle_ML.value || false;

            syncAddresses();
        };

        if (vehicleVM) {
            initVehicleValue();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vehicleVM]);

    useEffect(() => {
        if (!showPurchaseDateMonths()) {
            checkOwnedLessThanSixMonths();
            refreshData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vehicleVM]);

        useEffect(() => {
            setDefaultAmounts();

        const garagingLocation = _.get(vehicleVM, 'garagingLocation_ML.value', undefined);

        if (_.isUndefined(garagingLocation)) {
            _.set(vehicleVM, 'garagingLocation_ML.value', policyAddressNP);
            _.set(vehicleVM, 'parkedAtPrimary_ML.value', true);
        } else {
            _.set(vehicleVM, 'parkedAtPrimary_ML.value', isParkedAtPrimaryAddress());
        }

        const vehicleGaragingLocations =
          submissionVM.lobData.personalAuto.coverables.vehicles.value
            .map((location, index) => {
              const address = location?.garagingLocation_ML;

              if (!address?.addressLine1 ||!address?.city ||!address?.state || !address?.postalCode ) {
                return null;
              }

              return {
                ...address,
                code: `garagingLocation_ML_${index}`,
                name: `${address.addressLine1}, ${address.city}, ${address.state} ${address.postalCode}`,
              };
            }).filter(Boolean);

        findIndexOfCurrentVehicle(submissionVM.lobData.personalAuto.coverables.vehicles.value, vehicleVM.garagingLocation_ML.value.addressLine1);

        const allAvailableLocations = [
            ...vehicleGaragingLocations,
            {
                "code": "primaryNamedInsured_ML",
                "name": submissionVM.baseData.primaryNamedInsured_ML.primaryAddress?.displayName.value
            },
            {
                "code": "mailingAddress_ML",
                "name": submissionVM.baseData.mailingAddress_ML.displayName.value
            },
            {
                "code": "policyAddress",
                "name": submissionVM.baseData.policyAddress?.displayName.value
            },
            {
                "code": "priorAddress_Ext",
                "name": submissionVM.baseData.priorAddress_Ext?.displayName.value
            },
            {
                "code": "Add New Address",
                "name": "Add New Address",
            }
        ];

        updateAvailableLocations(removeDuplicates(allAvailableLocations));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const isPrivatePassengerCategory = () => {
        if (vehicleVM.category_ML?.value) {
            switch (vehicleVM.category_ML.value.code) {
                case 'private_passenger_light_truck':
                    return true;
                default:
                    return false;
            }
        }
        return false;
    };

    const isCollectibleCategory = () => {
        if (vehicleVM && vehicleVM.category_ML && vehicleVM.category_ML.value) {
            switch (vehicleVM.category_ML.value.code) {
                case 'collectible':
                    return true;
                default:
                    return false;
            }
        }
        return false;
    };

    const isOtherPersonallyRegistered = () => {
        if (vehicleVM?.category_ML?.value) {
            switch (vehicleVM.category_ML.value.code) {
                case 'Other_Personally_Registered':
                    return true;
                default:
                    return false;
            }
        }
        return false;
    }

    const isVendorAnnualMileageRequired = () => {
        return isPrivatePassengerCategory() && !!vehicleVM.vendorAnnualMileage_ML && !!_.get(vehicleVM, 'vendorAnnualMileage_ML.value')
    }

    const handlePrimaryParking = (value) => {
        if (!vehicleVM) {
            return;
        }

        _.set(vehicleVM, 'parkedAtPrimary_ML', value);
        vehicleVM.garagingLocation_ML.value = { ...policyAddress.value };
        updateViewModel();
    };

    const handleIgnitionInterlock = (value) => {
        if (!_.isUndefined(value)) {
            if (value.code === 'true') {
                _.set(vehicleVM, 'ignitionInterlockCert_Ext', true);
            } else {
                _.set(vehicleVM, 'ignitionInterlockCert_Ext', false);
                _.set(vehicleVM, 'interLockExpirationDate_Ext', null);
            }
        }

        updateViewModel();
    };

    const handleInterlockExpirationDate = (value) => {
        if (_.isUndefined(value)) {
            vehicleVM.interLockExpirationDate_Ext = null;
        } else {
            vehicleVM.interLockExpirationDate_Ext = value;
        }
        updateViewModel();
    };

    const setVehicleOwnerShip = useCallback(async (value) => {
        if (value === 'nonOwned') {
            _.set(vehicleVM, 'namedNonOwner_ML', true);
            _.set(vehicleVM, 'financeCategory_ML', undefined);
        } else {
            _.set(vehicleVM, 'financeCategory_ML', value);
            _.set(vehicleVM, 'namedNonOwner_ML', false);
        }
        updateViewModel();
    }, [updateViewModel, vehicleVM]);


    const getVehicleOwnerShipValue = useCallback(
        () => {
            return _.get(vehicleVM, 'financeCategory_ML.value.code', 'nonOwned');
        },
        [vehicleVM],
    );

    const getVehicleValueValidationMessages = useCallback(() => {
        const aspectValidationMessages = _.get(
            vehicleVM,
            'value_ML.amount.aspects.validationMessages',
            []
        );
        if (aspectValidationMessages.length > 0) {
            return aspectValidationMessages;
        }
        return [];
    }, [vehicleVM]);

        const getPrimaryUseValidationMessages = useCallback(() => {
        const aspectValidationMessages = _.get(
            vehicleVM,
            'primaryUse.aspects.validationMessages',
            []
        );
        if (aspectValidationMessages.length > 0) {
            return aspectValidationMessages;
        }
        return [];
    }, [vehicleVM]);

    const isStorageUseInvalid = () => {
        const vehicleYear = _.get(vehicleVM, 'year.value');
        const primaryUse = _.get(vehicleVM, 'primaryUse.value.code');
        return vehicleYear < 1970 && primaryUse === 'storage_np';
    };

    const getVehicleCostNewValidationMessages = useCallback(() => {
        const aspectValidationMessages = _.get(
            vehicleVM,
            'costNew.amount.aspects.validationMessages',
            []
        );

        if (aspectValidationMessages.length > 0) {
            return aspectValidationMessages;
        }
        return [];
    }, [vehicleVM]);

    const getValueTooltip = useCallback(() => {
        const state = vehicleVM && vehicleVM.licenseState && vehicleVM.licenseState.value && vehicleVM.licenseState.value.code;
        if (state === 'AZ') {
            return messages.valueToltipContentAZ;
        }
        if (state === 'NH') {
            return messages.valueToltipContentNH;
        }
        return messages.valueToltipContentRest;
    }, [vehicleVM]);

    const isTrailerCategory = useCallback(() => {
        return vehicleVM && vehicleVM.category_ML && vehicleVM.category_ML.value.code === 'trailer';
    }, [vehicleVM]);

    const isModelBridgedAndDefaultedByHVQ = (model) => {
        return !!(isFieldDefaultedByHvq && isFieldDefaultedByHvq(model._accessorCode));
    };


    const isDisputedVendorMileage = () => {
        return (vehicleVM.disputedVendorAnnualMileage_Ext && vehicleVM.disputedVendorAnnualMileage_Ext.value)
    };

    const annualMileageValue = () => {
        if (_.get(vehicleVM, 'hasVendorAnnualMileage.value') && !_.get(vehicleVM, 'disputedVendorAnnualMileage_Ext.value'))
            return null
        return _.get(vehicleVM, 'annualMileage.value')
    }

 const getSearchTooltipContent = () => {
  if (isQnb) {
    return messages.whatIsNonOwnedTooltipContentQb;
  }

  return  messages.whatIsNonOwnedTooltipContent;
  };

    const financialInterestWriteValue = useCallback((value, path) => {
        path = path.substr(1);
        _.set(vehicleVM, path, value);
        updateViewModel();
    }, [updateViewModel, vehicleVM]);

    const canDisplayAnnualMileage = () => {
        return !vehicleVM.hasVendorAnnualMileage_ML.value ||
            ((vehicleVM.disputedVendorAnnualMileage_Ext) && vehicleVM.disputedVendorAnnualMileage_Ext.value);
    }

    const isAnnualMileageRequiredByType = () => {
        if(isModernProductPersonalAuto){
            return !!((isPrivatePassengerNP()) && canDisplayAnnualMileage());
        } else {
            return !!(isPrivatePassengerCategory() && canDisplayAnnualMileage())
        }
    }

    const checkInterlockExpirationDateContainerVisible = () => {
        if (policyAddress.state.value?.code === 'MN' && vehicleVM.ignitionInterlockCert_Ext.value) {
            return true;
        }
        return false;
    };
    const findIndexOfCurrentVehicle = (vehicles, currentVehicleAddressLine1) => {
        const vehicleIndex = vehicles.findIndex(item => item.garagingLocation_ML.addressLine1 === currentVehicleAddressLine1);
        if (vehicleIndex !== -1) {
            setCurrentVehicleIndex(vehicleIndex)
        }
    };

    const isParkedAtPrimaryAddress = useCallback(() => {
        const keys = ['addressLine1', 'addressLine2', 'addressLine3', 'city', 'state', 'postalCode', 'country'];

        return _.isEqual(
                _.pick(_.get(vehicleVM, 'garagingLocation_ML.value'), keys),
                _.pick(policyAddressNP, keys)
            );
    }, [policyAddressNP, vehicleVM]);

    const handleParkedAtPrimaryField = (value, path) => {
        resetGarageValidation?.();
        handleValueChange(value, path);
 
        if (value) {
            _.set(vehicleVM, 'garagingLocation_ML.value', policyAddressNP);
            setShowAddNewAddressSection(false);
        } else {
            if (selectedGarageAddress === "Add New Address") {
                _.set(vehicleVM, 'garagingLocation_ML.value', {country: 'US'});
 
                setShowAddNewAddressSection(true);
            } else {
                const newLocation = availableLocations.find(
                    location => location.code === selectedGarageAddress
                );
 
                if (newLocation) {
                    _.set(vehicleVM, 'garagingLocation_ML.value', newLocation);
                }
 
                setShowAddNewAddressSection(false);
            }
        }
        updateWizardData(submissionVM);
    };
        const onChangeGarageAddress = (value) => {
          if (value === "primaryNamedInsured_ML") {
              _.set(vehicleVM, 'garagingLocation_ML.value', submissionVM.baseData.primaryNamedInsured_ML.primaryAddress.value);
          } else if (value === "mailingAddress_ML") {
              _.set(vehicleVM, 'garagingLocation_ML.value', submissionVM.baseData.mailingAddress_ML.value);
          } else if (value === "policyAddress") {
              _.set(vehicleVM, 'garagingLocation_ML.value', submissionVM.baseData.policyAddress.value);
          } else if (value === "priorAddress_Ext") {
              _.set(vehicleVM, 'garagingLocation_ML.value', submissionVM.baseData.priorAddress_Ext.value);
          } else if (value.indexOf("garagingLocation_ML") > -1) {
              const newLocation = availableLocations.find((location) => {
                  return location.code === value;
              });
              _.set(vehicleVM, 'garagingLocation_ML.value', newLocation);
          }
  
          setSelectedGarageAddress(value);
  
          if (value === "Add New Address") {
              setShowAddNewAddressSection(true);
              // Clearing the garagingLocation_ML and setting the coutry to 'US' to avoid becoming undefined on repeated changes 
              _.set(vehicleVM, 'garagingLocation_ML', { country: 'us' });
          } else {
              setShowAddNewAddressSection(false);
          }

          updateWizardData(submissionVM);
      }
            const saveNewGaragingAddress = (value, path) => {
              _.set(vehicleVM, path, value);
              refreshData();
              updateWizardData(submissionVM);
            };

   //Handles changes of the vehicle purchase date input
      const handleDateChange = (e) => {
          _.set(vehicleVM, 'vehiclePurchaseDate.value', e.target.value);
          refreshData();
          updateWizardData(submissionVM);
      }
    const getLabelNameForPurchasePrice = () => {
    
            if(isPrivatePassengerNP()){
                return translator(messages.agreedValueAmountLabel);
            }
            else if(isTrailer() || isCamper()){
                return translator(messages.purchasePriceLabel)
            }
        }
    const vehiclePurchaseDateValue = _.get(vehicleVM, 'vehiclePurchaseDate.value');
    const drivers = submissionVM?.lobData?.personalAuto?.coverables?.drivers?.value ?? [];
    const saved = _.get(vehicleVM, 'registeredOwners.value', []);
    
    const initialRegisteredOwners = Array.isArray(saved)
            ? saved.map(s => {
                const id = String(s.driverID ?? s.fixedId);
                const d = drivers.find(dr => String(dr.fixedId) === id);

                if (!d) return null;

                return {
                    id,
                    label: d.displayFullName_Ext || d.displayName,
                };
            }).filter(Boolean) : [];
    const [registeredOwnersValue, setRegisteredOwnersValue] = useState(initialRegisteredOwners);
    const handleOwnerChange = (selectedOptions) => {
            setRegisteredOwnersValue(selectedOptions);

            const selectedIds = (selectedOptions || []).map(o => String(o.id));
            const selectedDrivers = drivers
                .filter(d => selectedIds.includes(String(d.fixedId)))
                .map(d => ({
                    fixedId: d.fixedId,
                    displayName: d.displayFullName_Ext || d.displayName,
                    driverID: d.fixedId,
                }));

            if (typeof onRegisteredOwnerChange === 'function') {
                onRegisteredOwnerChange(selectedDrivers)
            }

            _.set(vehicleVM, 'registeredOwners.value', selectedDrivers);
            updateWizardData(submissionVM);
        };

        const checkDate = (dateValue, noError) => {
                
                    const vPurchaseDate = dateValue;
                    if (!vPurchaseDate?.day || !vPurchaseDate?.month || !vPurchaseDate?.year) { return true; }
                    const selected = new Date(vPurchaseDate?.year, vPurchaseDate?.month - 1, vPurchaseDate?.day);
                    const today = new Date();
                    const maxDate = new Date();
                    maxDate.setDate(today.getDate() + 7);
                    if (selected > maxDate) {
                        return true;
                    }
                    const validDate = moment(
                        { year: vPurchaseDate.year, month: vPurchaseDate.month - 1, day: vPurchaseDate.day },
                        true).isValid();
                    if (!validDate) return true;
                    return false;
                
            }

            const sortByCode = (a, b) => {
                if (a.code < b.code) {
                    return -1;
                }
                if (a.code > b.code) {
                    return 1;
                }
                return 0;
            }

            const getFinanceCatergoryAvailableValues = () => {
                    const availableFinanceCategories = [..._.get(vehicleVM, "financeCategory_ML.aspects.availableValues")]
                    availableFinanceCategories.sort((sortByCode))
                    return availableFinanceCategories.map((type) => {
                        return {
                            code: type.code,
                            name: translator({
                                id: type.name,
                                defaultMessage: type.name
                            })
                        };
                    });
                }


    const overrides = {
        vehicleHeader: {
            content: vehicleVM && showVehicleHeader && (
                <div>
                    <div className="summary-header vertical-spacing-20 align-flex-end">
                        <div className="summary-header__icon">
                            <span className="icon-ml-car-icon-outline" />
                        </div>
                        <div className="summary-header_content">
                            <span className="summary-header__count-text">
                                {vehicleHeaderMessage}
                            </span>
                            <div className="summary-header__item-title">
                                <span className="font-weight-bold">
                                    {vehicleVM.year.value}
                                    {' '}
                                    {vehicleVM.make.value}
                                </span>
                                {' '}
                                <span>{vehicleVM.model.value}</span>
                                {' '}
                                <span>{vehicleVM.trim_ML.value}</span>

                                <span>
                                    {' '}
                                    {showTrim(vehicleVM) && bodyTypename(vehicleVM)}
                                </span>
                                <span>
                                    {' '}
                                    {showCylinders(vehicleVM) && `${vehicleVM.cylinders_ML.value} cyl`}
                                </span>
                            </div>
                        </div>

                    </div>
                    <hr className="vertical-spacing-40" />
                </div>


            )

        },
        vendorAnnualMileageContainer: {
            visible: isVendorAnnualMileageRequired()
        },
        vendorAnnualMileageSpan: {
            content: translator(messages.vendorAnnualMileage, { value: _.get(vehicleVM, 'vendorAnnualMileage_ML.value') })
        },
        annualMileageContainer: {
            visible: isAnnualMileageRequiredByType() && !isModernProductPersonalAuto
        },
        parkingAddressPopoverContainer: {
            visible: _.get(vehicleVM, 'parkedAtPrimary_ML.value') === false && !isModernProductPersonalAuto
        },
        garageAddresspopover: {
            viewModel: _.get(vehicleVM, 'garagingLocation_ML'),
            policyState: policyAddress.state.value.code

        },
        parkingatprimary: {
            value: _.get(vehicleVM, 'parkedAtPrimary_ML.value'),
            onValueChange: (val) => handlePrimaryParking(val),
            label: isTrailerCategory() ? messages.trailerParkedatResidence : messages.vehicleParkedatResidence
        },
        purchaseYear: {
            availableValues: getCarPurchaseAvailableYears(),
            value: _.get(vehicleVM, 'purchaseDate_ML.year.value'),
            onValueChange: checkOwnedLessThanSixMonths,
            visible: !showPurchaseDateMonths() && (isPrivatePassengerCategory() || isCollectibleCategory()),
            required: (!showPurchaseDateMonths() && (isPrivatePassengerCategory() || isCollectibleCategory())) && isQnb ? true : vehicleVM.purchaseDate_ML.aspects.required
        },
        // TODO: update to MonthYear picker in Jutro 7.2 (Elysian)
        purchaseDate: {
            value: _.get(vehicleVM, 'purchaseDate_ML.value'),
            onBlur: (value) => checkOwnedLessThanSixMonths(value, 'purchaseDate_ML'),
            visible: showPurchaseDateMonths() && (isPrivatePassengerCategory() || isCollectibleCategory())
        },
        wasvehiclePurchasedin6monthContainer: {
            visible: showOwnedLessthanSixmonths && !isModernProductPersonalAuto,
            className: isQnb ? "vertical-spacing-20 radioButtonQnB" : "vertical-spacing-20"
        },
        vehiclePrimaryUseControl: {
            className: isQnb ? "radioButtonQnB col-md-12" : "col-md-12"
        },
        vehicleOwnership: {
            value: getVehicleOwnerShipValue(),
            onValueChange: (val) => setVehicleOwnerShip(val),
            className: isQnb ? "radioButtonQnB" : ""
        },
        vehicleValueTooltipComponent: {
            tooltipContent: getValueTooltip()
        },
        vehicleValueContainer: {
            visible: !isPrivatePassengerCategory() && !isModernProductPersonalAuto,
            className: isQnb ? "row help-text-row vertical-spacing-20 help-text-rowqb" : "row help-text-row vertical-spacing-20"
        },
        vehicleValue: {
            validationMessages: getVehicleValueValidationMessages()
        },
        vehiclePrimaryUseContainer: {
            visible: !isTrailerCategory() && !isOtherPersonallyRegistered() && !isModernProductPersonalAuto,
            className: isQnb ? "row help-text-row vertical-spacing-20 help-text-rowqb" : "row help-text-row vertical-spacing-20"
        },
        parkingAtPrimaryContainer: {
            className: isQnb ? "row help-text-row vertical-spacing-20 help-text-rowqb radioButtonQnB" : "row help-text-row vertical-spacing-20",
            visible: isQnb && !isModernProductPersonalAuto,
        },
        parkingtype: {
            visible: isPrivatePassengerCategory() || isCollectibleCategory() && !isModernProductPersonalAuto
        },
        parkingtypeWarningContainer: {
            visible: isModelBridgedAndDefaultedByHVQ(vehicleVM.parkingType_ML) && !isModernProductPersonalAuto
        },
        mileage: {
            visible: isPrivatePassengerCategory() && canDisplayAnnualMileage(),
            readOnly: isDisputedVendorMileage(),
            value: annualMileageValue()
        },
        financeCategoryTooltipContainer: {
            className: isQnb ? "col-md-6 tooltipContainerOverride tooltipContainerOverrideQb" : "col-md-6 tooltipContainerOverride"
        },
        vehicleCostNewContainer: {
            visible: (isPrivatePassengerCategory() || isPrivatePassengerNP()) && vehicleVM.isCostNewRequired_ML.value,
            className: isQnb ? 'row help-text-row vertical-spacing-20 help-text-rowqb' : 'row help-text-row vertical-spacing-20'
        },
        vehicleCostNew: {
            validationMessages: getVehicleCostNewValidationMessages(),
            onBlur: onBlurCostNew,
            required: true
        },
        conditionContainer: {
            visible: _.get(vehicleVM, 'condition_ML.aspects.required', false),
            className: isQnb ? "radioButtonQnB" : ""
        },
        conditionField: {
            visible: _.get(vehicleVM, 'condition_ML.aspects.required', false),
            value: _.get(vehicleVM, 'condition_ML.value.code')
        },
        conditionWarning: {
            visible: isModelBridgedAndDefaultedByHVQ(vehicleVM.condition_ML)
        },
        purchaseDateWarningContainer: {
            visible: isModelBridgedAndDefaultedByHVQ(vehicleVM.purchaseDate_ML)
        },
        wasvehiclePurchasedin6monthWarningContainer: {
            visible: showOwnedLessthanSixmonths && isModelBridgedAndDefaultedByHVQ(vehicleVM.ownedLessThan6Months_Ext)
        },
        annualMileageWarningContainer: {
            visible: isModelBridgedAndDefaultedByHVQ(vehicleVM.annualMileage)
        },
        hvqPageTitle: {
            visible: isCompRaterDefaultsPage
        },
        hvqPageSubTitle: {
            visible: isCompRaterDefaultsPage
        },
        ignitionInterlockContainer: {
            visible: policyAddress.state.value?.code === 'MN',
            className: isQnb ? "radioButtonQnB" : ""
        },
        ignitionInterlock: {
            value: {
                code: vehicleVM.ignitionInterlockCert_Ext && vehicleVM.ignitionInterlockCert_Ext.value
            },
            onValueChange: (val) => handleIgnitionInterlock(val)
        },
        interlockExpirationDateContainer: {
            visible: checkInterlockExpirationDateContainerVisible()
        },
        interlockExpirationDate: {
            value: _.get(vehicleVM, 'interLockExpirationDate_Ext.value'),
            onValueChange: (val) => handleInterlockExpirationDate(val)
        },
        repairedField: {
            visible: _.get(vehicleVM, 'salvagedTitle_ML.value') === true && !isOtherPersonallyRegistered() && !isModernProductPersonalAuto
        },
        financeCategoryTooltipComponent: {
            tooltipContent: getSearchTooltipContent(),
        },
        vehicleOwnershipContainer: {
            className: isQnb ? "help-text-row vertical-spacing-20 help-text-rowqb" : "help-text-row vertical-spacing-20",
            visible: isQnb && !isModernProductPersonalAuto
        },
        electFuelType: {
            visible: isModernProductPersonalAuto && !isTrailer() && !isCamper(),
            disabled:!(_.get(vehicleVM,'isFuelTypeValueEditable.value',false)) 
        },
        actualCashValueField: {
            visible: isModernProductPersonalAuto && (isTrailer() || isCamper())
        },
        purchasePriceField: {
            visible: isModernProductPersonalAuto && (isTrailer() || isCamper() || isPrivatePassengerNP()),
            label: getLabelNameForPurchasePrice(),
            required: isPrivatePassengerNP() && isVehicleYearPre1981()
        },
        registredOwnersField: {
            visible: isModernProductPersonalAuto && isPrivatePassengerNP(),
        },
        purchaseDateInputField: {
            visible: isModernProductPersonalAuto && isPrivatePassengerNP(),
            onChange: handleDateChange,
            value: vehiclePurchaseDateValue,
            stateMessages: {
                            error: checkDate(vehiclePurchaseDateValue, purchaseDateInputError) ? [translator(messages.purchaseDateInputErrorMessage)] : []
                        },
            onValidate
        },
        annualMileageContainerNP: {
            visible: isAnnualMileageRequiredByType() && isModernProductPersonalAuto,
            disabled: isDisputedVendorMileage()
        },
        annualMileageField: {
            disabled: isAnnualMileageRecentOrModeled() && isModernProductPersonalAuto,
            required: _.get(vehicleVM, 'isAnnualMileageRequired_ML.value', false) && isModernProduct
        },
        garageAddressLocation: {
         availableValues: availableLocations,
         value: showAddNewAddressSection
        ? 'Add New Address'
        : selectedGarageAddress ??
          (availableLocations.some(
              loc => loc.code === `garagingLocation_ML_${currentVehicleIndex}`
          )
              ? `garagingLocation_ML_${currentVehicleIndex}`
              : undefined),
          onValueChange: onChangeGarageAddress,
            visible: _.get(vehicleVM, 'parkedAtPrimary_ML.value') === false,
           validationMessages: showGarageAddressError && !showAddNewAddressSection
        ? [translator(messages.selectGarageError)]
        : []
},
        policyAddressContainer: {
            visible: _.get(vehicleVM, 'parkedAtPrimary_ML.value') === false && isModernProductPersonalAuto
        },
        addressComponent: {
            onValueChange: saveNewGaragingAddress,
            value: _.get(vehicleVM, 'garagingLocation_ML'),
            initialLockStateCity: false,
            showValidationErrors: showValidtionErrors,
            visible: showAddNewAddressSection && isModernProductPersonalAuto,
        },
        altGarageStateErrorContainer: {
            visible: showAltAddressStateError && isModernProductPersonalAuto,
            role: "alert"
        },
        parkingTypeContainer: {
            visible: !isOtherPersonallyRegistered() && isWhereParkedRequired() && isModernProductPersonalAuto
        },
        vehiclePrimaryUseContainerNP: {
            visible: isModernProductPersonalAuto && isPrivatePassengerNP(),
            className: isQnb ? "radioButtonQnB primaryUseRow w100": "primaryUseRow"
        },
        vehicleFinanceCategoryFieldNP: {
            visible: isQnb && isModernProductPersonalAuto,
            availableValues: getFinanceCatergoryAvailableValues(),
            value: _.get(vehicleVM, 'financeCategory_ML.value.code'),
            className: isQnb ? "radioButtonQnB margin-top-30": "margin-top-30"
        },
        parkedAtPrimaryFieldNP: {
            label: isTrailer() ? translator(messages.parkedAtPrimaryTrailer) : translator(messages.parkedAtPrimary),
            tooltip: {
                title: translator(messages.tooltipWhatDoesThisMean),
                text: isTrailer() ? translator(messages.parkingTooltipTextTrailer) : translator(messages.parkingTooltipText),
            },
            onValueChange: handleParkedAtPrimaryField,
            className: isQnb ? "radioButtonQnB" : ""
        },
        parkingContainerNP: {
            visible: isQnb && isModernProductPersonalAuto
        },
        parkingAtPrimaryControl: {
            className: isQnb ? "col-md-12 radioButtonQnB" : "col-md-12"
        },
        parkingAtPrimaryTooltipContainer: {
            className: isQnb ? "col-md-6 tooltipContainerOverride parkingAtPrimaryTooltipQB" : "col-md-6 tooltipContainerOverride"
        },
        vehiclePrimaryUseNP: {
            validationMessages: isStorageUseInvalid() ? [translator(messages.isStorageUseInvalidMsg)] : getPrimaryUseValidationMessages()
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate
        },
        resolveComponentMap: {
            MLPAVehicleGarageLocationComponent: MLPAVehicleGarageLocationComponent,
            DateInput,
                        mlparegisteredOwners: (props) => (
                            <MLPARegisteredOwnersComponent
                                {...props}
                                drivers={drivers}
                                registeredOwnersValue={registeredOwnersValue}
                                onChange={handleOwnerChange}
                            />
                        )
        }

    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={vehicleVM}
            showErrors={showValidtionErrors}
            classNameMap={styles}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            onValidationChange={onValidate}
            onModelChange={handleVehicleModelChange}
            onValueChange={handleValueChange}
        />
    );
}

MLPAEditVehicleComponent.propTypes = {
    vehicleVM: PropTypes.shape({}).isRequired,
    submissionVM: PropTypes.shape({}).isRequired,
    showValidtionErrors: PropTypes.bool,
    handleVehicleModelChange: PropTypes.func,
    onValidate: PropTypes.func.isRequired,
    vehicleHeaderMessage: PropTypes.string,
    bodyTypename: PropTypes.func,
    showTrim: PropTypes.func,
    showCylinders: PropTypes.func,
    policyAddress: PropTypes.shape({}),
    effectiveDate: PropTypes.shape({}),
    updateViewModel: PropTypes.func.isRequired,
    isCompRaterDefaultsPage: PropTypes.bool,
    showVehicleHeader: PropTypes.bool,
    updateWizardData: PropTypes.func,
    showAltAddressStateError: PropTypes.bool,
    purchaseDateInputError: PropTypes.bool
};

MLPAEditVehicleComponent.defaultProps = {
    showValidtionErrors: false,
    handleVehicleModelChange: _.noop,
    vehicleHeaderMessage: undefined,
    bodyTypename: _.noop,
    showTrim: _.noop,
    showCylinders: _.noop,
    policyAddress: undefined,
    effectiveDate: undefined,
    isCompRaterDefaultsPage: false,
    showVehicleHeader: true,
    updateWizardData: (value) => { },
    showAltAddressStateError:false,
    purchaseDateInputError: false
};


export default MLPAEditVehicleComponent;
